// export class ReqModulePermissionList { 
//     constructor({applyId}) {
//         this.applyId = applyId
//     }

//     fromJson(jsonDate) {
//         this.applyId = jsonDate.applyId
//     }
// }

// export class RespModulePermissionList { 
//     constructor({moduleId}) {
//         this.moduleId = moduleId
//     }

//     fromJson(jsonDate) {
//         this.moduleId = jsonDate.moduleId
//     }
// } 

export class RespModulePermissionListItem { 
    constructor({applyId, mobile, nickName, items}) {
        this.applyId = applyId
        this.mobile = mobile
        this.nickName = nickName
        this.items = items
    }

    fromJson(jsonDate) {
        this.applyId = jsonDate.applyId
        this.mobile = jsonDate.mobile
        this.nickName = jsonDate.nickName
        try {
            this.items = JSON.parse(jsonDate.items) 
        } catch (error) {
            this.items = []
        }
    }
}

export class ReqModulePermissionItem {
    constructor({ applyId, items }) {
        this.applyId = applyId
        this.items = items
    }

    fromJson(jsonData){
        this.applyId = jsonData.applyId
        try {
            this.items = JSON.parse(jsonData.items) 
        } catch (error) {
            this.items = []
        }
    }
}